module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/339.7b6398fb.png";